import React from 'react';
import { checkForCustomerCartReset } from '../utils/globals/checkForCustomerCartReset';
import LocaleProvider from './providers/locale';

export const wrapPageElement = ({ element, props }) => {
  const { pageContext } = props;
  const { node_locale, slug } = pageContext;
  if (node_locale) {
    const locale = node_locale.toLowerCase();

    // Check for shopify cart reset
    checkForCustomerCartReset(pageContext);

    return (
      <LocaleProvider
        locale={locale}
        slug={slug}>
        {element}
      </LocaleProvider>
    );
  } else {
    return '';
  }
};
